module.exports = __webpack_public_path__ + "img/21.645ee409.png";